/**
*ここにカスタムJavaScriptを含めてください。
*
*独自のロジックをプラグインできるように、いくつかのフックも提供しています。たとえば、バリアントのときに通知されたい場合
*製品ページで変更すると、リスナーをドキュメントに添付できます。
*
* document.addeventlistener（ 'variant：chander'、function（event）{
* var variant = event.detail.variant;//バリアントの詳細全体にアクセスできます
*}）;
*
*製品をカートに追加するたびに、リスナーを追加することもできます。
*
* document.addeventlistener（ 'crodce：add'、function（event）{
* var variant = event.detail.variant;//追加されたバリアントを取得します
* var数量= event.detail.quantity;//追加された数量を取得します
*}）;
*
*特定の製品を追加せずにミニカートを強制的に更新したい場合は、イベントをトリガーできます
*「カート：リフレッシュ」も同様の方法で（その場合、量を渡すことは必要ありません）：
*
* document.documentelement.dispatchevent（new Customevent（ 'cart：refresh'、{
*バブル：本当
*}））;
*/

const header_cls = '.LPHeader_nav,.LPHeader_menu';
var NavElem = [];	// ナビゲーションのliの何番目かを定義するための準備
var ElemTop = [];		// 基準点の準備
console.log('[Start] custom.js...');

// DOMの読み込み後に実行
document.addEventListener('DOMContentLoaded', function() {
});


// ページ読込時
$(window).on('load', function() {

	// 「トップへ」ボタンクリック時
	$('#toTop').on('click', function () {
		$('html,body').animate(
			{ scrollTop: 0 },
			'fast'
		);
	});
	
	// LP用js
	if($('.LPContainer').length > 0){

		// 現在地を取得する関数を呼ぶ
		PositionCheck();
		// ナビゲーションに現在地のクラスをつけるための関数を呼ぶ
		ScrollAnime();

		// オーナーコメントのスライダー不備を調整
		var checkClassInterval = setInterval(function() {
			// スライダー取得
			var element = document.querySelector('.js-flickity');
			if (element) {
				var viewport = element.querySelector('.flickity-viewport');
				var selectedItem = viewport.querySelector('.is-selected');
				if (viewport && selectedItem) {
					var viewportHeight = viewport.getBoundingClientRect().height;
					var selectedHeight = selectedItem.getBoundingClientRect().height;

					// スライダー枠の方が中身より小さいかを調査
					if (viewportHeight < selectedHeight) {

						// 中身の方が大きい場合、viewportの高さを調整する
						viewport.style.height = selectedHeight + 'px';
						console.log('flickity-viewportの高さを調整');
					} else {

						// 監視を停止
						clearInterval(checkClassInterval);
					}
				}
			}
		}, 200); // Xミリ秒ごとに確認

		// ハンバーガーメニュークリック時
		$('#LPHeaderTrigger').on('click', function () {
			if ($(this).hasClass('active')) {
				// OPEN→CLOSE
				closeMenu();
			} else {
				// CLOSE→OPEN
				openMenu();
			}
		});
	}
});

// 画面スクロール時
$(window).scroll(function () {
	
	// LP用js
	if($('.LPContainer').length > 0){
		// 現在地を取得する関数を呼ぶ
		PositionCheck();
		// ナビゲーションに現在地のクラスをつけるための関数を呼ぶ
		ScrollAnime();
	}

});

// 画面リサイズ時
$(window).resize(function() {
	
	// LP用js
	if($('.LPContainer').length > 0){
		// 現在地を取得する関数を呼ぶ
		PositionCheck();
	}
});

// 現在地を取得するための設定を関数でまとめる
function PositionCheck(){

	// ナビゲーションのliの何番目かを定義するための準備
	if(NavElem.length == 0){
		NavElem = $("#HeaderNav li a");
	}

	// headerの高さを取得
	var headerH = $("#Header").outerHeight(true);

	// アンカーリンク先の位置を取得
	NavElem.each(function(i){
		var href = $(this).attr('href')
		ElemTop[i] = Math.round(parseInt($(href).offset().top - headerH));	// 追従するheader分の高さ（70px）を引き小数点を四捨五入
	});
}
// ナビゲーションに現在地のクラスをつけるための設定
function ScrollAnime() {

	// スクロールした際のナビゲーションの関数にまとめる
	var scroll = Math.round($(window).scrollTop());
	NavElem.removeClass('current');	// 全てのナビゲーションの現在地クラスを除去

	// 飛び先の要素をループ
	NavElem.each(function(i){

		// 一番上の要素
		if(0 == i){
			if(scroll >= 0 && scroll < ElemTop[1]) {
				$(NavElem[i]).addClass('current');
				return;
			}

		// 一番下の要素
		}else if(i == NavElem.length - 1){
			if(scroll >= ElemTop[i]) {
				$(NavElem[i]).addClass('current');
				return;
			}
			
		// 間の要素
		}else{
			if(scroll >= ElemTop[i] && scroll < ElemTop[i+1]) {
				$(NavElem[i]).addClass('current');
				return;
			}
		}
	});
}

// ナビゲーションをクリックした際のスムーススクロール
$('#HeaderNav a').click(function () {
	var elmHash = $(this).attr('href'); 										// hrefの内容を取得
	var headerH = $("#Header").outerHeight(true);						// 追従するheader分の高さ（70px）を引く
	var pos = Math.round($(elmHash).offset().top-headerH);	// headerの高さを引き小数点を四捨五入
	$('body,html').animate({scrollTop: pos}, 500);
	return false;	// リンクの無効化
});

// ナビメニューを開く
function openMenu() {
	$('#LPHeaderTrigger').addClass('active');
	$(header_cls).addClass('open');
}
// ナビメニューを閉じる
function closeMenu() {
	$('#LPHeaderTrigger').removeClass('active');
	$(header_cls).removeClass('open');
}
